import React, { useContext, useEffect, useState } from 'react'
import { MainLanguageContext } from '../context/MainLanguageContext';
import usePost from '../customHooks/usePost';
import useGet from '../customHooks/useGet';
import { Link } from 'react-router-dom';
import plus from '../dist/webImages/plus.png'
import { Pagination } from 'antd';
import SkeletonPromotionsCard from './SkeletonPromotionsCard';
import PromotionsCard from './PromotionsCard';

const Promotions = () => {
    const { mainLanguage } = useContext(MainLanguageContext);
    const [datas, setDatas] = useState()
    const [resget, apiMethodGet] = useGet()
    const [currentPage, setCurrentPage] = useState(1)
    const [paginationn, setPaginationn] = useState(6);
    const [searchValue, setSearchValue] = useState("")
    const [res2, apiMethod2] = usePost()


    const onChange = (current, pageSize) => {
        setCurrentPage(current)
        let formdata = new FormData();
        formdata.append('search_query', searchValue);
        if ((searchValue).trim()) {
            apiMethod2(`promotions/search_promotions_list/${mainLanguage}/6?page=${current}`, formdata);
        } else {
            apiMethodGet(`promotions/list/${mainLanguage}/6?page=${current}`, formdata);
        }
    };

    useEffect(() => {
        if (mainLanguage) {
            setCurrentPage(1)
            apiMethodGet(`promotions/list/${mainLanguage}/6?page=1`);
        }
    }, [mainLanguage]);


    let debounceTimer;
    const debounce = (func, delay) => {
        return (...args) => {
            clearTimeout(debounceTimer);
            debounceTimer = setTimeout(() => {
                func(...args);
            }, delay);
        };
    };


    const executeApiCall = (e) => {
        setSearchValue(e.target.value)
        let formdata = new FormData();
        formdata.append('search_query', e.target.value);
        if ((e.target.value).trim()) {
            apiMethod2(`promotions/search_promotions_list/${mainLanguage}/6?page=${currentPage}`, formdata);
        } else {
            apiMethodGet(`promotions/list/${mainLanguage}/6?page=${currentPage}`, formdata);
        }
    };
    const handleChange = debounce(executeApiCall, 1000)


    useEffect(() => {
        if (!resget.isLoading) {
            setDatas(resget?.data?.data)
            setPaginationn(resget.data?.pagination)
        }

    }, [resget.data])

    useEffect(() => {
        setDatas([])
        if (res2.data) {
            setDatas(res2?.data?.data);
            setPaginationn(res2?.data?.pagination)
        }
    }, [res2.data]);
    return (
        <div className='Promotions'>
            <div className="TeamPageTop flex justify-end items-center w-full">
                <div className='flex gap-1 items-center'>
                    <div className="inputBox w-[16rem] max-lg:hidden">
                        <input type="text" onChange={handleChange} className='w-full border rounded-full px-4 border-[#ddd] outline-none py-[0.45rem]' placeholder='Search' />
                    </div>
                    <Link to={"/promotions/create"} className='bg-[#A38560]/50 py-2 px-4 rounded-full flex items-center gap-2 cursor-pointer'>
                        <img src={plus} alt="plus" className="w-6" />
                        <span className='font-MluvkaBold text-secondary capitalize text-[.9rem]'>Add Promotions</span>
                    </Link>
                </div>
            </div>

            <div className="NewsPageGrid mt-4 rounded-[10px] grid grid-cols-2 gap-3 max-lg:grid-cols-1 max-lg:p-3">
                {resget.isLoading ?
                    Array.from({ length: 6 }).map((_, index) => (
                        <React.Fragment key={index}>
                            <SkeletonPromotionsCard />
                        </React.Fragment>
                    ))
                    :
                    Array.isArray(datas) && datas.map((item, index) => {
                        return (
                            <React.Fragment key={index}>
                                <PromotionsCard data={item} alldata={datas} deleted={setDatas} />
                            </React.Fragment>
                        )
                    })}
            </div>
            <div className='mt-4'>
                <Pagination
                    onChange={onChange}
                    defaultCurrent={currentPage}
                    total={paginationn?.total}
                    pageSize={6}
                />
            </div>
        </div>
    )
}

export default Promotions